import { Injectable } from '@angular/core';
import { ISecurity, ISecurityType, ISecuritySymbolList, ISecurityCustomCategories, ISecurityModelList, IViewOption, IEqvSecCategoryList } from '../irb-models.model';
import { HttpClient, HttpHeaders, HttpResponse } from '@angular/common/http';
import {Observable, of} from 'rxjs';
import {delay, map, tap} from 'rxjs/operators';
import { AppService } from '@irb/app.service';
import { IUserDetails } from '@irb/app.model';
import { IModelExportRequest } from '../models-new/models.service';
import { SecurityMasterComponent } from './security-master.component';

@Injectable({
  providedIn: 'root'
})
export class SecurityMasterService {

  private userDetails: IUserDetails;
  filterCriteria: string = '';
  filterCriteriaForExport: string = '';
  _sortCriteria: string = '';
  noDollarCash: boolean = false;
  isUseSecurityService = false;
  securityServiceUrlPrefix = '/irebalone/security';
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json',
      'Cache-Control': 'no-cache',
      'Pragma': 'no-cache',
      'Expires': 'Sat, 01 Jan 2000 00:00:00 GMT'
    })
  };
  constructor(private readonly http: HttpClient, private appService: AppService, private _http: HttpClient) {
    this.isUseSecurityService = this.appService.getItem('IRB_APP_CONFIG')?.featureFlags?.ENABLE_SECURITY_APIS || false;
    if (this.isUseSecurityService)
      this.securityServiceUrlPrefix = '/irebal-security';
    else
      this.getUserDetails();
  }

  getUserDetails(): void {
    this.appService.getUserDetails().subscribe((res: IUserDetails) => {
      if (res) {
        this.userDetails = res;
        this.isUseSecurityService = this.userDetails.featureFlags && this.userDetails.featureFlags.ENABLE_SECURITY_APIS;
        if (this.isUseSecurityService)
          this.securityServiceUrlPrefix = '/irebal-security';
      }
    });
  }

  getInvSecurityMaster(params: any, parent: any): Observable<HttpResponse<ISecurity[]>> {
    const headers = new HttpHeaders({
        'X-HTTP-Method-Override': 'GET',
        'Filter-Item': 'items=' + params.request.startRow + '-' + (--params.request.endRow)
      });
    let sort = '';
    let filterKeys = '';

    if (params.request.filterModel && params.request.filterModel['securitySymbol']) {
      const encodedName = encodeURIComponent(params.request.filterModel['securitySymbol'].values);
      filterKeys = filterKeys + '%26securitySymbol%3D' + encodedName;
    }

    if (params.request.filterModel && params.request.filterModel['securityType']) {
      filterKeys = filterKeys + '%26securityType%3D' + params.request.filterModel['securityType'].values;
    }

    if (params.request.filterModel && params.request.filterModel['securityDescription']) {
      filterKeys = filterKeys + '%26securityDescription%3D' + encodeURIComponent(params.request.filterModel['securityDescription'].filter);
    }

    if (params.request.filterModel && params.request.filterModel['customCategoryName']) {
      filterKeys = filterKeys + '%26customCategoryId%3D' + parent.getCustomCategoryFilterIds(params, parent.customCategoriesList, 'customCategoryName');;
    }

    if (params.request.filterModel && params.request.filterModel['styleBoxLabel']) {
      filterKeys = filterKeys + '%26styleBoxLabel%3D' + parent.getMorningstarStyleIds(params);
    }

    if (params.request.filterModel && params.request.filterModel['sacSecurityType']) {
      filterKeys = filterKeys + '%26sacSecurityType%3D' + params.request.filterModel['sacSecurityType'].values;
    }

    if (params.request.filterModel && params.request.filterModel['acLevel1']) {
      filterKeys = filterKeys + '%26acLevel1Filter%3D' + parent.getAssetClassIds(params).acLevel1;
    }

    if (params.request.filterModel && params.request.filterModel['acLevel2']) {
      filterKeys = filterKeys + '%26acLevel2Filter%3D' + parent.getAssetClassIds(params).acLevel2;
    }

    if (params.request.filterModel && params.request.filterModel['acLevel3']) {
      filterKeys = filterKeys + '%26acLevel3Filter%3D' + parent.getAssetClassIds(params).acLevel3;
    }

    if (params.request.filterModel && params.request.filterModel['acLevel4']) {
      filterKeys = filterKeys + '%26acLevel4Filter%3D' + parent.getAssetClassIds(params).acLevel4;
    }

    if (params.request.filterModel && params.request.filterModel['securityModels']) {
      filterKeys = filterKeys + '%26securityModel%3D' + parent.getSecModelFilterSelectedGetIds(params, parent.securityModelList, 'securityModels');
    }

    if (params.request.filterModel && params.request.filterModel['sellingTreatment']) {
      filterKeys = filterKeys + '%26sellingTreatment%3D' + params.request.filterModel['sellingTreatment'].values;
    }

    if (params.request.filterModel && params.request.filterModel['equivalenceQty']) {
      filterKeys = filterKeys + '%26eqvSecCatId%3D' + parent.getEqvFilterSelectedGetIds(params, parent.eqvSecCategoryList, 'equivalenceQty');
    }

    if (params.request.filterModel && params.request.filterModel['isTlhEnabled']) {
      const selectedTlhValues = params.request.filterModel['isTlhEnabled'].values;
      if(selectedTlhValues.length>1 && selectedTlhValues.indexOf('On')!== -1 && selectedTlhValues.indexOf('Off')!== -1) {
      } else if (selectedTlhValues.length === 1 ){
        if (selectedTlhValues.indexOf('On')!== -1) {
          filterKeys = filterKeys + '%26isTlhEnabled%3Dtrue';
        }
        if (selectedTlhValues.indexOf('Off')!== -1) {
          filterKeys = filterKeys + '%26isTlhEnabled%3Dfalse';
        }
      }
    }

    if (params.request.filterModel && params.request.filterModel['tlhWashSaleSymbol']) {
      let selectedWashSaleSecIds = parent.getWashSaleFilterIds(params, parent.securityList, 'tlhWashSaleSymbol')
      if (selectedWashSaleSecIds && selectedWashSaleSecIds.length > 0) {
        filterKeys = filterKeys + '%26tlhWashSaleSymbol%3D' + selectedWashSaleSecIds;
        filterKeys = filterKeys + '%26tlhWashSaleSymbolCount%3D' + parent.washSaleSymbolList.length;

      }
    }
    
    if (params.request.filterModel && params.request.filterModel['createdDate']) {
      const fromDate = params.request.filterModel['createdDate'].filterFrom;
      const toDate = params.request.filterModel['createdDate'].filterTo;
      const filterValue = params.request.filterModel['createdDate'].type + ',' + fromDate + ',' + toDate;
      filterKeys = filterKeys + '%26createdDate%3D' + filterValue;
    }
    
    let noCash = "";
    if (this.noDollarCash) {
      noCash = '&Cash=false';
    }

    if (params.request.sortModel.length > 0) {
      const sortColumn = params.request.sortModel[0].colId;
      const sortOrder = (params.request.sortModel[0].sort === 'asc') ? '+' : '-';
      sort = '&sort(' + sortOrder + sortColumn + ')';
    }

    if (filterKeys) {
      this.filterCriteria = '&Filter=' + filterKeys;
      this.filterCriteriaForExport = filterKeys;
    }
    parent.saveGridFiltersToLocal(parent._filterChipModel);

    return this.http.post<ISecurity[]>('/irebalone/security/security-inv' + '?' + sort + noCash, {
      'Filter': filterKeys,
    },
      { headers: headers, observe: 'response' })
      .pipe(delay(1000), tap(_res => {
        //console.log(res.headers.get('Filter-Count'));
      })
      );
  }

  getSecurityMasterCount(): Observable<number> {
    let url = `${this.securityServiceUrlPrefix}/get-securities-count`;
    return this.http.get<number>(url).pipe(map(res => this.defineResponse(res)));
  }

  getComboDropDownSecurityType(): Observable<ISecurityType> {
    let url = `${this.securityServiceUrlPrefix}/get-security-types`;
    return this.http.get<ISecurityType>(url).pipe(map(res => this.defineResponse(res)));
  }

  getSecuritySymbolDropDownValues(): Observable<ISecuritySymbolList> {
    let url = `${this.securityServiceUrlPrefix}/get-sec-symbol-drop-down`;
    return this.http.get<ISecuritySymbolList>(url).pipe(map(res => this.defineResponse(res)));
  }

  getCustomCategorDropDownValues(): Observable<ISecurityCustomCategories> {
    let url = `${this.securityServiceUrlPrefix}/get-custom-categories`;
    return this.http.get<ISecurityCustomCategories>(url).pipe(map(res => this.defineResponse(res)));
  }

  getSecurityModelDropDownValues(): Observable<ISecurityModelList> {
    let url = `${this.securityServiceUrlPrefix}/get-sorted-security-models`;
    return this.http.get<ISecurityModelList>(url).pipe(map(res => this.defineResponse(res)));
  }

  getOptionView(param: any): Observable<IViewOption[]> {
    let url = `${this.securityServiceUrlPrefix}/get-options/`;
    return this.http.get<IViewOption[]>(url + param).pipe(map(res => this.defineResponse(res)));
  }

  getSelectedSecurityIds(data: any): Observable<ISecurityType> {
    data.filter = decodeURIComponent(this.filterCriteria !== undefined ? this.filterCriteria : '');
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');
    return this.http.post<ISecurityType>('/irebalone/security/get-securities-by-filter', data);
  }

  getSelectedSecurityMinDetails(data: any): Observable<ISecurityType> {
    data.filter = decodeURIComponent(this.filterCriteria !== undefined ? this.filterCriteria : '');
    data.sort = decodeURIComponent(this._sortCriteria !== undefined ? this._sortCriteria : '');
    return this.http.post<ISecurityType>('/irebalone/security/lean/securities', data);
  }

  exportEquivalents(data: IModelExportRequest): Observable<Blob> {
    data.filter = decodeURIComponent(this.filterCriteriaForExport !== undefined ? this.filterCriteriaForExport : '');
    return this.http.post('/irebalone/security/async/export-securities-equivalents', data, { responseType: 'blob' });
  }

  exportSecuritySymAndCat(data: IModelExportRequest): Observable<Blob> {
    data.filter = decodeURIComponent(this.filterCriteriaForExport !== undefined ? this.filterCriteriaForExport : '');
    return this.http.post('/irebalone/security/async/export-securities-symbol-and-categories', data, { responseType: 'blob' });
  }

  exportSecurityDetails(data: IModelExportRequest): Observable<Blob> {
    data.filter = decodeURIComponent(this.filterCriteriaForExport !== undefined ? this.filterCriteriaForExport : '');
    return this.http.post('/irebalone/security/async/export-securities-info', data, { responseType: 'blob' });
  }

  importEquivalents(formData: any): Observable<Object> {
    return this._http.post("/irebalone/security/import-security-equivalents", formData, { responseType: 'text' as 'json' });
  }

  updateEquivalents(data: any): Observable<any> {
    return this._http.post("/irebalone/security/update-import-security-equivalents", data, this.httpOptions);
  }

  //IREBAL-26684
  updateEquivalentsAsync(data: any): Observable<any> {
    return this._http.post("/irebalone/security/async/update-import-security-equivalents", data, this.httpOptions);
  }
  
  importSecuritiesCategory(formData: any): Observable<Object> {
    return this._http.post("/irebalone/security/import-securities", formData, { responseType: 'text' as 'json' });
  }

  updateNewSecurityProfiles(data: any): Observable<any> {
    return this._http.post("/irebalone/security/add-new-security-profiles", data, this.httpOptions);
  }

  checkSecurities(data: ICreateSecurites[]): Observable<any> {
    return this._http.post("/irebalone/security/check-securities", data, this.httpOptions);
  }

  checkSecurityAvailble(data: string): Observable<any> {
    return this._http.post("/irebalone/security/security-exists-check", data, this.httpOptions);
  }

  deleteSelectedSecurities(deleteSecurities: ISecurity[]): Observable<any> {
    return this.http.post<any>('/irebalone/security/async/delete-selected-securities', JSON.stringify(deleteSecurities), this.httpOptions);
  }

  getDeleteSelectedModelStatus(statusId: string): Observable<Object> {
    const e = encodeURIComponent(statusId);
    let url = `${this.securityServiceUrlPrefix}/get-int-async-response-data/${e}`;
    return this.http.get(url).pipe(map(res => this.defineResponse(res)));
  }

  getDetailsBeforeMoveOrDelete(data: any): Observable<any> {
    return this.http.post<ISecurityType>('/irebalone/security/get-details-before-move-or-delete', data);
  }

  getDetailsBeforeMoveOrDeleteAsync(data: any): Observable<any> {
    return this.http.post<ISecurityType>('/irebalone/security/get-details-before-move-or-delete-async', data);
  }

  getDetailsBeforeMoveOrDeleteStatusCheck(actionStatusId: any) {
    return this._http.get('/irebalone/security/get-async-status-with-blob/' + actionStatusId).pipe(delay(1000));
  }
  
  getRestrictionTypeDropDownValues(): Observable<ISecurityType> {
    return this.http.get<ISecurityType>('/irebalone/security/get-security-restrictions').pipe(delay(1000));
  }

  getEqvSecCategoryDropdown(): Observable<IEqvSecCategoryList> {
    let url = `${this.securityServiceUrlPrefix}/get-eqv-sec-category-dropdown`;
    return this.http.get<IEqvSecCategoryList>(url).pipe(map(res => this.defineResponse(res)));
  }

  clearCriteria() {
    this.filterCriteria = '';
    this.filterCriteriaForExport = '';
    this.noDollarCash = false;
  }

  getMutualFundSecurityDetails(id: number): Observable<any> {
    return this.http.get<ISecurity>('/irebalone/security/get-mutual-fund-security-details/' + id);
  }

  getSecurityACLevels(_id: number): Observable<any> {
    let url = "/irebalone/security/get-security-aclevels/";
    return this.http.get(url + _id);
  }

  actionStatusCheck(actionStatusId: any) {
    if (!/^[0-9]+$/.test(actionStatusId)) {
      throw new Error("Invalid character payload.");
    } else {
      const e = encodeURIComponent(actionStatusId);
      const u = "/irebalone/security/get-import-status/*".replace("*",e);
      return this._http.get(u);
    }

    
    // false && console.log(actionStatusId);
    // return of({
    //   "responseStatus": "SUCCESS",
    //   "responseData": "<html><body><textarea>{\"unRecogCustCategory\":{\"count\":0},\"errorSymbols\":{\"data\":[],\"count\":0},\"Inventoried\":{\"data\":[{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"AMERICAN BEACON LARGE CAP VALUE R5\",\"securitySymbol\":\"AADEX\",\"customCategoryId\":\"1081436\",\"securityCUSIP\":\"02368A208\",\"fundName\":\"AADEX\",\"taxInitialPurchase\":\"250000\",\"qualInitialPurchase\":\"250000\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"LgValue\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":1076580,\"versionId\":121,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"ADVISORSHARES DORSEY WRGT ADR ETF IV\",\"securitySymbol\":\"AADR\",\"securityCUSIP\":\"00768Y206\",\"fundName\":\"AADR\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"LgValue\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":16832422,\"versionId\":0,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"Aia Group Ltd ADR\",\"securitySymbol\":\"AAGIY\",\"securityCUSIP\":\"001317205\",\"fundName\":\"AAGIY\",\"taxInitialPurchase\":\"0\",\"qualInitialPurchase\":\"0\",\"taxSubsPurchase\":\"0\",\"qualSubsPurchase\":\"0\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"LgValue\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":3055680,\"versionId\":18,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"MORGAN STANLEY INSIGHT A\",\"securitySymbol\":\"CPOAX\",\"customCategoryId\":\"1081435\",\"securityCUSIP\":\"61747T106\",\"fundName\":\"CPOAX\",\"taxInitialPurchase\":\"1\",\"qualInitialPurchase\":\"1\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"LgGrowth\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":2137724,\"versionId\":121,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"Capri Holdings Ltd\",\"securitySymbol\":\"CPRI\",\"customCategoryId\":\"0\",\"securityCUSIP\":\"G1890L107\",\"fundName\":\"CPRI\",\"taxInitialPurchase\":\"0\",\"qualInitialPurchase\":\"0\",\"taxSubsPurchase\":\"0\",\"qualSubsPurchase\":\"0\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"Uncategorized\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":2610176,\"versionId\":18,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"Copart Inc\",\"securitySymbol\":\"CPRT\",\"securityCUSIP\":\"217204106\",\"fundName\":\"CPRT\",\"taxInitialPurchase\":\"0\",\"qualInitialPurchase\":\"0\",\"taxSubsPurchase\":\"0\",\"qualSubsPurchase\":\"0\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"Uncategorized\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":16847919,\"versionId\":2,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"ISHARES 0-5 YEAR TIPS BOND ETF\",\"securitySymbol\":\"STIP\",\"customCategoryId\":\"1081425\",\"securityCUSIP\":\"46429B747\",\"fundName\":\"STIP\",\"taxInitialPurchase\":\"0\",\"qualInitialPurchase\":\"0\",\"taxSubsPurchase\":\"0\",\"qualSubsPurchase\":\"0\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"InflProtBnd\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":89331,\"versionId\":285,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"Zebra Technologies A\",\"securitySymbol\":\"ZBRA\",\"customCategoryId\":\"0\",\"securityCUSIP\":\"989207105\",\"fundName\":\"ZBRA\",\"taxInitialPurchase\":\"0\",\"qualInitialPurchase\":\"0\",\"taxSubsPurchase\":\"0\",\"qualSubsPurchase\":\"0\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"Uncategorized\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":2876480,\"versionId\":18,\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"EQUITY\",\"securityDescription\":\"ZIFF DAVIS INC\",\"securitySymbol\":\"ZD\",\"customCategoryId\":\"0\",\"securityCUSIP\":\"48123V102\",\"fundName\":\"ZD\",\"taxInitialPurchase\":\"0\",\"qualInitialPurchase\":\"0\",\"taxSubsPurchase\":\"0\",\"qualSubsPurchase\":\"0\",\"oldCustomCategory\":\"Uncategorized\",\"newCustomCategory\":\"Uncategorized\",\"isCustomCategoryOverridden\":false,\"securityBehaviour\":\"BASE\",\"securityId\":1197109,\"versionId\":20,\"isNTF\":false,\"isFollowingCatSuggestion\":false}],\"count\":9},\"unRecognized\":{\"data\":[{\"securityType\":\"\",\"securityDescription\":\"\",\"securitySymbol\":\"STI\",\"customCategoryId\":\"0\",\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"\",\"securityDescription\":\"\",\"securitySymbol\":\"ZEN\",\"customCategoryId\":\"0\",\"isNTF\":false,\"isFollowingCatSuggestion\":false},{\"securityType\":\"\",\"securityDescription\":\"\",\"securitySymbol\":\"ZFI00\",\"customCategoryId\":\"0\",\"isNTF\":false,\"isFollowingCatSuggestion\":false}],\"count\":3},\"warningCustomCategories\":false,\"validRecords\":[{\"object\":[\"AADEX\",\"ZFI00\",\"Y\",\"\"]},{\"object\":[\"AADR\",\"ZEOIX\",\"N\",\"\"]},{\"object\":[\"AADYX\",\"ZEN\",\"Y\",\"\"]},{\"object\":[\"AAENX\",\"ZD\",\"N\",\"\"]},{\"object\":[\"AAGIY\",\"ZBRA\",\"Y\",\"\"]},{\"object\":[\"CPOAX\",\"STIP\",\"N\",\"\"]},{\"object\":[\"CPRI\",\"STI\",\"Y\",\"\"]},{\"object\":[\"CPRT\",\"STHTX\",\"N\",\"\"]},{\"object\":[\"CPSH\",\"STHC\",\"Y\",\"\"]},{\"object\":[\"CPTNX\",\"STEW\",\"N\",\"\"]}],\"CSVImportDetails\":{\"isCSVInAValidFormat\":false},\"invalidRecords\":[],\"invalidCustomCategories\":[],\"NonInventoried\":{\"data\":[{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"AMERICAN CENTURY GOVERNMENT BOND INV\",\"securitySymbol\":\"CPTNX\",\"securityCUSIP\":\"025081308\",\"fundName\":\"American Century Investments\",\"taxInitialPurchase\":\"1\",\"qualInitialPurchase\":\"1\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"initialPurchase\":\"1\",\"subsPurchase\":\"1\",\"redemptionPenaltyPercent\":0.0,\"redemptionPenaltyDays\":0,\"fundFamilyCode\":\"0C00001YUA\",\"fundFamilyName\":\"American Century Investments\",\"classCode\":\"POOL\",\"loadType\":\"NL\",\"isNTF\":true,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":207},{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"CAVANAL HILL STRATEGIC ENHANCED YLD A\",\"securitySymbol\":\"AAENX\",\"securityCUSIP\":\"14956P166\",\"fundName\":\"Cavanal Hill funds\",\"taxInitialPurchase\":\"100000\",\"qualInitialPurchase\":\"100000\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"initialPurchase\":\"100000\",\"subsPurchase\":\"1\",\"redemptionPenaltyPercent\":0.0,\"redemptionPenaltyDays\":0,\"fundFamilyCode\":\"0C00001I3V\",\"fundFamilyName\":\"Cavanal Hill funds\",\"classCode\":\"POOL\",\"loadType\":\"FL\",\"isNTF\":false,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":44397074},{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"OSTERWEIS SHORT DURATION CREDIT INV\",\"securitySymbol\":\"ZEOIX\",\"securityCUSIP\":\"74316P694\",\"fundName\":\"Osterweis\",\"taxInitialPurchase\":\"1\",\"qualInitialPurchase\":\"1\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"initialPurchase\":\"1\",\"subsPurchase\":\"1\",\"redemptionPenaltyPercent\":0.0,\"redemptionPenaltyDays\":0,\"fundFamilyCode\":\"0C00001YSV\",\"fundFamilyName\":\"Osterweis\",\"classCode\":\"POOL\",\"loadType\":\"NL\",\"isNTF\":false,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":82522188},{\"securityType\":\"EQUITY\",\"securityDescription\":\"Southcorp Capital\",\"securitySymbol\":\"STHC\",\"securityCUSIP\":\"84129L103\",\"classCode\":\"EQ\",\"isNTF\":false,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":736979905},{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"VIRTUS SEIX HIGH INCOME I\",\"securitySymbol\":\"STHTX\",\"securityCUSIP\":\"92837F722\",\"fundName\":\"Virtus\",\"taxInitialPurchase\":\"1\",\"qualInitialPurchase\":\"1\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"initialPurchase\":\"1\",\"subsPurchase\":\"1\",\"redemptionPenaltyPercent\":0.0,\"redemptionPenaltyDays\":0,\"fundFamilyCode\":\"0C00001YUH\",\"fundFamilyName\":\"Virtus\",\"classCode\":\"POOL\",\"loadType\":\"NL\",\"isNTF\":true,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":1017076416},{\"securityType\":\"EQUITY\",\"securityDescription\":\"SRH TOTAL RETURN CF\",\"securitySymbol\":\"STEW\",\"securityCUSIP\":\"101507101\",\"fundName\":\"SRH Total Return Fund, Inc.\",\"fundFamilyCode\":\"0C00001I1Z\",\"fundFamilyName\":\"SRH Total Return Fund, Inc.\",\"classCode\":\"POOL\",\"isNTF\":false,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":1050532229},{\"securityType\":\"MUTUAL_FUND\",\"securityDescription\":\"INVESCO SELECT RISK: GROWTH INVESTOR Y\",\"securitySymbol\":\"AADYX\",\"securityCUSIP\":\"00888U613\",\"fundName\":\"Invesco\",\"taxInitialPurchase\":\"1\",\"qualInitialPurchase\":\"1\",\"taxSubsPurchase\":\"1\",\"qualSubsPurchase\":\"1\",\"initialPurchase\":\"1\",\"subsPurchase\":\"1\",\"redemptionPenaltyPercent\":0.0,\"redemptionPenaltyDays\":0,\"fundFamilyCode\":\"0C00006B4V\",\"fundFamilyName\":\"Invesco\",\"classCode\":\"POOL\",\"loadType\":\"NL\",\"isNTF\":true,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":1731049813},{\"securityType\":\"EQUITY\",\"securityDescription\":\"C P S Technologies C\",\"securitySymbol\":\"CPSH\",\"securityCUSIP\":\"12619F104\",\"classCode\":\"EQ\",\"isNTF\":false,\"isFollowingCatSuggestion\":false,\"schwabSecurityId\":1849047009}],\"count\":8}}</textarea></body></html>",
    //   "responseUtilityMap": {
    //     "requestStatus": "COMPLETED"
    //   }
    // });

    // return of({
    //   "responseStatus": "SUCCESS",
    //   "responseData": "<html><body><textarea>{\"message\":\"499 records and above msg.\",\"status\":\"fail\"}</textarea></body></html>",
    //   "responseUtilityMap": {
    //     "requestStatus": "COMPLETED"
    //   }
    // });

    // return of({
    //   "responseStatus": "SUCCESS",
    //   "responseData": "IN_PROGRESS",
    //   "responseUtilityMap": {
    //     "requestStatus": "IN_PROGRESS"
    //   }
    // });

  }

  importSecurityEquivalentsAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/security/import-security-equivalents-async", formData);
    // false && console.log(data);
    // return of({
    //     "responseStatus": "SUCCESS",
    //     "responseData": null,
    //     "responseUtilityMap": {
    //         "statusId": 251
    //     }
    // });
  }

  importSecuritiesCategoryAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/security/async/import-securities", formData);
  }

  addNewSecurityProfilesAsync(data: any): Observable<any> {
    return this._http.post("/irebalone/security/add-new-security-profiles-async", data, this.httpOptions);
  }

  importTLHWSAValidateAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/security/async/import-tlh-wsa-validate", formData);
  }

  importTLHWSAImportAsync(formData: any): Observable<Object> {
    return this._http.post("/irebalone/security/async/update-import-tlh-securities", formData);
  }

  exportWashSaleAlternates(data: IModelExportRequest): Observable<Blob> {
    data.filter = decodeURIComponent(this.filterCriteriaForExport !== undefined ? this.filterCriteriaForExport : '');
    return this.http.post('/irebalone/security/async/export-wash-sale-alternates', data, { responseType: 'blob' });
  }

  getACLevels(): Observable<Object> {
    return this.http.get("/irebalone/security/get-ac-levels");
  }

  defineResponse(res: any) {
    return  res && res.data && res.data.irebalResponse ? res.data.irebalResponse : res;
  }
}

export interface ICreateSecurites {
  securityId: number;
  securitySymbol: string;
  securityDescription: string;
  securityType: string;
  customCategoryId: string;
  externalSharePrice: any;
  SecurityTypeEnum: string;
  securityCUSIP: string;
  underlyingSymbol: string;
  underlyingCusip: string;
  expirationDate: string;
  strikePrice: number;
  putCalIndicator: string
}
export interface SecurityDeleteDTO {
  securityId: number;
  versionId: number;
}
export interface ISecurityUsageData {
  relatedAs: string;
  relatedToDesc: string;
  relatedToName: string;
  securitySymb: string;
}

export interface ISecurityHardDataInfo {
  symbol: string;
  reason: string;
  location: string;
}
